export default function rxDirective() {
  return {
    restrict: 'A',
    priority: 2000,
    scope: {
      rx: "=rx"
    },
    link: function postLink(scope, element, attrs) {

      var obs = scope.rx;

      if (!isObservable(obs)) {
        return;
      }
      var subscription = obs.safeApply(scope, function (items) {
        scope.rx = items;
      }).subscribe();

      scope.$on('$destroy', function () {
        subscription.dispose();
      });
    }
  };

  function isObservable(obj) {
    return obj && typeof obj.subscribe === 'function';
  }
}
